import './index.css'
import cn from 'clsx'

import React from 'react'
type Props = {
  error?: React.ReactNode | React.ReactNode[]
  status?: 'danger' | 'warning'
}

/**
 * An inline error component that displays error messages with appropriate styling and icon.
 * Supports both danger and warning states with different visual treatments.
 *
 * @param error - The error message(s) to display. Can be a string, ReactNode, or array of strings
 * @param status - The severity level of the error (default: 'danger')
 * @returns The error component with icon and message, or null if no error provided
 */
const InlineError = ({
  error,
  status = 'danger',
}: Props): null | React.ReactElement<'div'> => {
  if (!error) return null
  return (
    <div
      className={cn('InlineError', {
        'InlineError--danger': status === 'danger',
        'InlineError--warning': status === 'warning',
      })}
    >
      <svg className="InlineError-icon" width="16" height="16">
        <path
          fill="currentcolor"
          d="M8 1.333A6.67 6.67 0 0 0 1.333 8 6.67 6.67 0 0 0 8 14.667 6.67 6.67 0 0 0 14.667 8 6.67 6.67 0 0 0 8 1.333zm0 7.334A.669.669 0 0 1 7.333 8V5.333c0-.366.3-.666.667-.666.367 0 .667.3.667.666V8c0 .367-.3.667-.667.667zm.667 2.666H7.333V10h1.334v1.333z"
        />
      </svg>
      {Array.isArray(error) ? error.join(' ') : error}
    </div>
  )
}

export default InlineError
